//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'
export default {
  components: { FeatureGuidePanel },
  data () { return { list: [], stats: null } },
  computed: {
    backTarget () { return this.$route.query.from === 'mine' ? '/mine' : '/home' }
  },
  created () {
    this.$ajax.get(this.$api.etTreeMyList).then(r => { this.list = (r && r.list) || [] }).catch(() => {})
    this.$ajax.get(this.$api.etForestStats).then(r => { this.stats = r }).catch(() => {})
  },
  methods: {
    go (id) { this.$router.push({ path: '/etDetail_display', query: { id } }) },
    levelText (lv) {
      return ({ 1: '种子', 2: '发芽', 3: '幼苗', 4: '小树', 5: '大树', 6: '参天' })[lv] || ('Lv.' + (lv || 1))
    },
    roleText (r) {
      return ({ creator: '创建者', member: '成员' })[r] || r || ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/index.vue